import { FC } from 'react';
import { Button, ConfigProvider, ButtonProps } from 'antd';
import { createStyles } from 'antd-style';

const useStyle = createStyles(({ prefixCls, css }) => ({
  linearGradientButton: css`
    &.${prefixCls}-btn-primary:not([disabled]):not(.${prefixCls}-btn-dangerous) {
      border-width: 0;

      > span {
        position: relative;
      }

      &::before {
        content: '';
        background: linear-gradient(90deg, #6c63f9 0%, #6d3dff 100%);
        position: absolute;
        inset: 0;
        opacity: 1;
        transition: all 0.3s;
        border-radius: inherit;
      }

      &:hover::before {
        opacity: 0;
      }
    }
  `,
}));

export const GradientButton: FC<ButtonProps> = props => {
  const { styles } = useStyle();

  return (
    <ConfigProvider
      button={{
        className: styles.linearGradientButton,
      }}
      theme={{
        components: {
          Button: {
            colorBgContainerDisabled: 'linear-gradient(90deg, #2F2C6B 0%, #301D6D 98%)',
          },
        },
      }}>
      <Button type="primary" {...props} />
    </ConfigProvider>
  );
};
